// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"52627747","579":"de27a70c","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};